import { useState } from 'react';
import { collection, addDoc, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/firestore';

export function useProductForm(onSuccess) {
  const [form, setForm] = useState({
    id: null,
    title: '',
    categories: [],
    shortDescription: '',
    fullDescription: '',
    specifications: [{ key: '', value: '' }],
    image: '',
    price: '',
    stock: '',       // основной товар: остаток теперь необязательный
    rating: '',
    reviews: '',
    discount: '',
    variations: [],  // массив вариаций
  });

  const [formError, setFormError] = useState('');
  const [formLoading, setFormLoading] = useState(false);

  const resetForm = () => {
    setForm({
      id: null,
      title: '',
      categories: [],
      shortDescription: '',
      fullDescription: '',
      specifications: [{ key: '', value: '' }],
      image: '',
      price: '',
      stock: '',
      rating: '',
      reviews: '',
      discount: '',
      variations: [],
    });
    setFormError('');
  };

  const fillForm = (product) => {
    setForm({
      ...product,
      specifications:
        Array.isArray(product.specifications) && product.specifications.length > 0
          ? product.specifications
          : [{ key: '', value: '' }],
      discount: product.discount !== undefined ? product.discount : '',
      variations: Array.isArray(product.variations) ? product.variations : [],
    });
    setFormError('');
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    const numericFields = ['price', 'stock', 'rating', 'reviews', 'discount'];
    setForm((prev) => ({
      ...prev,
      [name]: numericFields.includes(name) ? (value === '' ? '' : Number(value)) : value,
    }));
    setFormError('');
  };

  const handleCategoryChange = (selectedOptions) => {
    setForm((prev) => ({
      ...prev,
      categories: selectedOptions.map((opt) => opt.value),
    }));
  };

  const handleSpecificationChange = (index, field, value) => {
    setForm((prev) => {
      const specs = [...prev.specifications];
      specs[index] = { ...specs[index], [field]: value };
      return { ...prev, specifications: specs };
    });
  };

  const addSpecification = () => {
    setForm((prev) => ({
      ...prev,
      specifications: [...prev.specifications, { key: '', value: '' }],
    }));
  };

  const removeSpecification = (index) => {
    setForm((prev) => {
      const specs = [...prev.specifications];
      specs.splice(index, 1);
      return { ...prev, specifications: specs };
    });
  };

  // ======== Вариации ========
  const handleVariationChange = (index, field, value) => {
    setForm((prev) => {
      const vars = [...prev.variations];
      vars[index] = { ...vars[index], [field]: field === 'price' || field === 'stock' || field === 'discount' ? (value === '' ? '' : Number(value)) : value };
      return { ...prev, variations: vars };
    });
  };

  const addVariation = () => {
    setForm((prev) => ({
      ...prev,
      variations: [...prev.variations, { name: '', price: '', stock: '', discount: '' }],
    }));
  };

  const removeVariation = (index) => {
    setForm((prev) => {
      const vars = [...prev.variations];
      vars.splice(index, 1);
      return { ...prev, variations: vars };
    });
  };
  // ======== Конец вариаций ========

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Валидация обязательных полей (stock теперь необязательный)
    if (!form.title || form.categories.length === 0 || !form.shortDescription || !form.image || !form.price) {
      setFormError('Пожалуйста, заполните обязательные поля.');
      return;
    }

    // Проверка скидки на валидность
    if (form.discount !== '' && (form.discount < 0 || form.discount > 100)) {
      setFormError('Скидка должна быть от 0 до 100.');
      return;
    }

    // Проверка вариаций: цена обязательна, stock и discount необязательны
    for (let v of form.variations) {
      if (!v.name || v.price === '') {
        setFormError('Вариации должны иметь название и цену.');
        return;
      }
      if (v.discount !== '' && (v.discount < 0 || v.discount > 100)) {
        setFormError('Скидка вариации должна быть от 0 до 100.');
        return;
      }
    }

    setFormLoading(true);

    const payload = {
      title: form.title,
      categories: form.categories,
      shortDescription: form.shortDescription,
      fullDescription: form.fullDescription,
      specifications: form.specifications,
      image: form.image,
      price: Number(form.price),
      stock: form.stock === '' ? null : Number(form.stock), // stock необязательный
      rating: parseFloat(form.rating) || 0,
      reviews: parseInt(form.reviews) || 0,
      discount: form.discount === '' ? 0 : Number(form.discount),
      variations: form.variations.map(v => ({
        name: v.name,
        price: Number(v.price),
        stock: v.stock === '' ? null : Number(v.stock),
        discount: v.discount === '' ? 0 : Number(v.discount),
      })),
    };

    try {
      if (form.id) {
        await updateDoc(doc(db, 'products', form.id), payload);
      } else {
        await addDoc(collection(db, 'products'), payload);
      }
      onSuccess();
    } catch (err) {
      console.error('Ошибка при сохранении:', err);
      setFormError('Не удалось сохранить данные.');
    } finally {
      setFormLoading(false);
    }
  };

  return {
    form,
    formError,
    formLoading,
    setForm,
    resetForm,
    fillForm,
    handleFormChange,
    handleCategoryChange,
    handleSpecificationChange,
    addSpecification,
    removeSpecification,
    handleFormSubmit,
    handleVariationChange,
    addVariation,
    removeVariation,
    handleVariationChange,  // <-- добавляем
    addVariation,           // <-- добавляем
    removeVariation,        // <-- добавляем
  };
}
